/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
import '../../components/Rte/rte-style.css'
import '../../components/List/list-style.css'
export default () => import('./index')